import React from 'react';
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import './Tutorial.scss'

import {
    Navbar,
    Header,
    StepHeader,
    FormBox
} from '../../components/_index';

export default function Tutorial() {
    return (
        <>
            <div className="wrapper">
                <Header langLock="langLocked" />
                <div className="mainWrapper">
                    <Navbar />
                    <div className="contentWrapper">
                        <div className="title">
                          Tutorial
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
